// AutoMapper
import { AutoMap } from '@nartc/automapper';

export class DraftCallbackDetailDto {
    @AutoMap() reason: number;
    @AutoMap() situation: number;
    @AutoMap() gender: number;
    @AutoMap() lastName: string;
    @AutoMap() firstName: string;
    @AutoMap() dateOfBirth: Date;
    @AutoMap() relationId: number;
    @AutoMap() deathDate: Date;
    @AutoMap() funeralDate: Date;
    @AutoMap() hospitalizationDate: Date;
    @AutoMap() comment: string;
    @AutoMap() residence: string;
    @AutoMap() postalCode: string;
    @AutoMap() address: string;
    @AutoMap() houseNumber: string;
    @AutoMap() city: string;
    @AutoMap() countryId: string;
    @AutoMap() numberOfFellowTravellers: string;
    @AutoMap() from: string;
    @AutoMap() to: string;
    @AutoMap() journeyType: number;
    @AutoMap() returnDate: Date;
    @AutoMap() luggage: string;
    @AutoMap() wheelchair: string;
    @AutoMap() bookingNumber: string;
    @AutoMap() airline: string;
    @AutoMap() isAirLineBooked: boolean;
}